export default __webpack_public_path__ + "static/media/raku.b53dfc01.jpeg";